import { createStyles, makeStyles } from '@forgeglobal/design-framework';

export const useStyles = makeStyles(() =>
  createStyles({
    profile: {
      marginLeft: 'auto',
      display: 'flex',
      width: 'max-content',
    },
  })
);
